import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_INQ004_Request,
  IAPI_INQ004_Response,
} from "../../../type/apiType";

// 職員照会参照
const httpAPI_INQ004 = async (
  param: IAPI_INQ004_Request
): Promise<IAPI_INQ004_Response> => {
  let res = await http.post(ApiUrl.API_INQ004, {
    ...param,
  });

  return res.data;
};

export { httpAPI_INQ004 };
